import React from 'react';

import PropTypes from 'prop-types';

import { dig } from 'spiceutils';
import { RadioButton } from 'spicecomponents';

class CdfRadioButtons extends React.Component {
  onChange(value) {
    const {
      options,
      type,
      updateCDF,
    } = this.props;

    const option = options[parseInt(value, 10)];
    updateCDF(type, option.value === undefined ? null : option.value);
  }

  getValueFromProps() {
    const {
      cdf,
      type,
      options,
    } = this.props;
    const item = cdf[type];

    return options.findIndex(({ value }) => item === value).toString();
  }

  render() {
    const {
      type,
      controlList,
      options,
      label,
    } = this.props;

    if (dig(controlList, [type, 'Visible']) === true) {
      return (
        <div>
          <label htmlFor={type}>{label}</label>
          <RadioButton
            name={type}
            options={options.map(({ text, value }, index) => ({ text: text || value, value: index.toString() }))}
            value={this.getValueFromProps()}
            onChange={(v) => this.onChange(v)}
          />
        </div>
      );
    }
    return null;
  }
}

CdfRadioButtons.propTypes = {
  updateCDF: PropTypes.func,
  cdf: PropTypes.object,
  controlList: PropTypes.object,
  type: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
};

export default CdfRadioButtons;



// WEBPACK FOOTER //
// ./app/components/FormControls/CdfRadioButtons/index.js